import { FC, useState } from "react"
import React from "react"
import classNames from "classnames"
import { FormGroup, Label, Input, InputProps } from "reactstrap"
import { v4 } from "uuid"
import { SuggestBoxInput } from './SuggestboxInput'

type LabeledInputProps = InputProps & {
    label: string
    describedBy?: string
    small?: boolean
    boldLabel?: boolean
    className?: string
    textArea?: boolean

    suggestbox?: {
        options: string[]
    }
}

export const LabeledTextInput: FC<LabeledInputProps> = ({
    suggestbox, textArea, label, className, describedBy, small, boldLabel, ...inputProps
}) => {

    const [elementId] = useState(v4())

    return (
        <FormGroup
            className={classNames(
                "m-0",
                className
            )}
        >
            <Label
                className={classNames(
                    { "small": small },
                    { "font-weight-bold": boldLabel }
                )}
                htmlFor={elementId}
            >
                {label}
            </Label>

            {suggestbox && (
                <SuggestBoxInput
                    type={textArea != null ? "textarea" : undefined}
                    id={elementId}
                    aria-describedby={describedBy}
                    bsSize={small != null ? "sm" : undefined}
                    {...inputProps}

                    suggestbox={{
                        options: suggestbox.options,
                        onChange: (event) => {
                            inputProps.onChange && inputProps.onChange(event)
                        }
                    }}
                />
            )}

            {suggestbox == null && (
                <Input
                    type={textArea != null ? "textarea" : undefined}
                    id={elementId}
                    aria-describedby={describedBy}
                    bsSize={small != null ? "sm" : undefined}
                    {...inputProps}
                />
            )}
        </FormGroup>
    )
}
